/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import { createApp } from 'vue'

import Cims from './cims';
import Claim from './Claim';
import Client from './Client';
import Acknowledgement from './Acknowledgement';
import ClaimFilter from './ClaimFilter';
import QbExport from './QbExport';
import FeeScheduleForm from './FeeSchedules/FeeScheduleForm.js';
import InvoiceForm from './Invoices/InvoiceForm.js';
import BsImageComponent from './bscomponents/bsimage';
import JournalFilter from './JournalFilter';
import Report from './Report';
import EmailsBulkSelector from "./EmailsBulkSelector";
import BulkHelper from './BulkHelper';
import AdjusterDeploy from './AdjusterDeploy';
import TokenLetter from "./TokenLetter";
import User from './User';
import AdjusterSearch from './AdjusterSearch';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { createPinia } from 'pinia';
import stores from "./stores";
import directives from "./directives/";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const pinia = createPinia()
const app = createApp({mixins: [stores]})
app.use(pinia)

import Helpers from "./components/mixins/Helpers"
app.mixin(Helpers)

app.component('QuillEditor', QuillEditor);

app.component('datepicker', require('./components/Datepicker.vue').default);
app.component('upload-box', require('./components/UploadBox.vue').default);
app.component('modal', require('./components/Modal.vue').default);
app.component('expandable', require('./components/Expandable.vue').default);
app.component('simple-confirmation-modal', require('./components/SimpleConfirmationModal.vue').default);
app.component('form-bulk-modal', require('./components/modals/FormBulkModal.vue').default);
app.component('pagination', require('./components/Pagination.vue').default);
app.component('typeahead', require('./components/Typeahead.vue').default);
app.component('email-typeahead', require('./components/EmailTypeahead.vue').default);
app.component('email-compose', require('./components/EmailCompose.vue').default);
app.component('g-map-modal', require('./components/GMapModal.vue').default);
app.component('google-auth-setup', require('./components/2fa/googleAuthSetup').default);
app.component('chosen', require('./components/Chosen.vue').default);
app.component('image-view-modal', require('./components/modals/ImageViewModal.vue').default);
app.component('countdown-button', require('./components/CountDownButton').default);
app.component('item-list', require('./components/ItemList').default);
app.component('vue-select', require('./components/controls/VueSelect.vue').default);
app.component('vue-chosen', require('./components/controls/VueChosen.vue').default);
app.component('register-shared-list', require('./components/RegisterSharedList.vue').default);

app.component('base-filter-selector', require('./components/base-filters/BaseFilterSelector.vue').default);

app.component('stormform', require('./components/StormForm.vue').default);
app.component('text-campaign-adjusters', require('./components/text-campaigns/TextCampaignAdjusters.vue').default);
app.component('text-campaign-modal', require('./components/text-campaigns/TextCampaignModal.vue').default);
app.component('text-campaign-response-editor', require('./components/text-campaigns/TextCampaignResponseEditor').default);
app.component('text-campaign-delete-adjusters-modal', require('./components/text-campaigns/TextCampaignDeleteAdjustersModal').default);
app.component('text-campaign-send-message-modal', require('./components/text-campaigns/TextCampaignSendMessageModal').default);
app.component('text-campaign-response-form', require('./components/text-campaigns/admin/TextCampaignResponseForm.vue').default);
app.component('text-campaign-reply-option-form', require('./components/text-campaigns/admin/TextCampaignReplyOptionForm.vue').default);
app.component('text-campaign-ms-import', require('./components/text-campaigns/admin/TextCampaignMSImport.vue').default);
app.component('text-campaign-delete-ms-modal', require('./components/text-campaigns/admin/TextCampaignDeleteMSModal.vue').default);
app.component('text-campaign-ms-status-modal', require('./components/text-campaigns/admin/TextCampaignMSStatusModal.vue').default);
app.component('lookupitemform', require('./components/LookupItemForm.vue').default);
app.component('acceptterms', require('./components/TermsAccept.vue').default);
app.component('journalform', require('./components/JournalForm.vue').default);
app.component('claim-journal-bulk-operations', require('./components/ClaimJournalBulkOperations.vue').default);
app.component('claim-uploads-bulk-operations', require('./components/ClaimUploadsBulkOperations.vue').default);
app.component('wf-export-modal', require('./components/modals/WfExportModal.vue').default);
app.component('diary-date-select', require('./components/DiaryDateSelect.vue').default);
app.component('diary-date-form', require('./components/DiaryDateForm.vue').default);
app.component('diary-date-reason-lookup-item-modal', require('./components/DiaryDateReasonLookupItemModal.vue').default);
app.component('user-access-form', require('./components/UserAccessForm.vue').default);
app.component('report-access', require('./components/ReportAccess.vue').default);
app.component('contact-view', require('./components/contacts/ContactView.vue').default);
app.component('contact-form', require('./components/contacts/ContactForm.vue').default);
app.component('contact-list', require('./components/contacts/ContactList.vue').default);
app.component('contact-type-lookup-item-modal', require('./components/contacts/ContactTypeLookupItemModal').default);
app.component('task-lookup-item-modal', require('./components/claim-tasks/TaskLookupItemModal').default);
app.component('filter-columns', require('./components/FilterColumns.vue').default);
app.component('adjuster-search', require('./components/AdjusterSearch.vue').default);
app.component('bs-phones', require('./bscomponents/BsPhones.vue').default);
app.component('bs-emails', require('./bscomponents/BsEmails.vue').default);
app.component('bs-quilleditor', require('./bscomponents/BsQuilleditor.vue').default);
app.component('adjuster-list-g-map', require('./components/adjuster/AdjusterListGMap.vue').default);
app.component('adjuster-certifications', require('./components/adjuster/AdjusterCertifications.vue').default);
app.component('adjuster-experience', require('./components/adjuster/AdjusterExperience.vue').default);
app.component('adjuster-licenses', require('./components/adjuster/AdjusterLicenses.vue').default);
app.component('adjuster-nfip', require('./components/adjuster/AdjusterNfip.vue').default);
app.component('adjuster-attachments', require('./components/adjuster/AdjusterAttachments.vue').default);
app.component('adjuster-lookup-item-modal', require('./components/adjuster/AdjusterLookupItemModal.vue').default);
app.component('adjuster-notes-modal', require('./components/adjuster/AdjusterNotesModal.vue').default);
app.component('adjuster-followup-modal', require('./components/adjuster/AdjusterFollowupModal.vue').default);
app.component('adjuster-upload-modal', require('./components/adjuster/AdjusterUploadModal.vue').default);
app.component('adjuster-upload-edit-modal', require('./components/adjuster/AdjusterUploadEditModal.vue').default);
app.component('adjuster-user-link-modal', require('./components/adjuster/AdjusterUserLinkModal.vue').default);
app.component('adjuster-to-cims-button', require('./components/adjuster/AdjusterToCimsUserButton.vue').default);
app.component('delete-file-upload-modal', require('./components/modals/DeleteFileUploadModal.vue').default);
app.component('edit-file-upload-modal', require('./components/modals/EditFileUploadModal.vue').default);
app.component('approve-file-upload-modal', require('./components/modals/ApproveFileUploadModal.vue').default);
app.component('reject-file-upload-modal', require('./components/modals/RejectFileUploadModal.vue').default);
app.component('change-claim-status-modal', require('./components/modals/ChangeClaimStatusModal.vue').default);
app.component('inspected-claim-modal', require('./components/modals/InspectedClaimModal.vue').default);
app.component('adjuster-contact-modal', require('./components/modals/AdjusterContactModal.vue').default);
app.component('examiner-contact-modal', require('./components/modals/ExaminerContactModal.vue').default);
app.component('assign-claim-modal', require('./components/modals/AssignClaimModal.vue').default);
app.component('send-for-packaging-modal', require('./components/modals/SendForPackagingModal.vue').default);
app.component('accept-claim-modal', require('./components/modals/AcceptClaimModal.vue').default);
app.component('reject-claim-modal', require('./components/modals/RejectClaimModal.vue').default);
app.component('form-upload-modal', require('./components/modals/FormUploadModal.vue').default);
app.component('applications-merge', require('./components/adjuster/ApplicationsMerge.vue').default);
app.component('application-merge-preview-modal', require('./components/adjuster/ApplicationMergePreviewModal').default);
app.component('application-approve-modal', require('./components/adjuster/ApplicationApproveModal').default);
app.component('archive-explorer', require('./components/ArchiveExplorer').default);
app.component('form-explorer', require('./components/form-groups/FormExplorer').default);
app.component('form-group', require('./components/form-groups/FormGroup').default);
app.component('form-group-files', require('./components/form-groups/FormGroupFiles').default);
app.component('login-message-list', require('./components/system-utilities/login-banner-tool/LoginMessageList').default);
app.component('email-signature-list', require('./components/system-utilities/email-signature/EmailSignatureList').default);
app.component('appointment-modal', require('./components/modals/AppointmentModal').default);
app.component('delete-invoice-modal', require('./components/modals/DeleteInvoiceModal').default);
app.component('approve-invoice-modal', require('./components/modals/ApproveInvoiceModal').default);
app.component('claim-task-form', require('./components/claim-tasks/TaskForm.vue').default);
app.component('claim-task-list', require('./components/claim-tasks/TaskList.vue').default);
app.component('claim-task-rule-modal', require('./components/claim-tasks/TaskRuleModal.vue').default);
app.component('approve-tpa-queue-item-modal', require('./components/modals/ApproveTpaQueueItemModal.vue').default);
app.component('reject-tpa-queue-item-modal', require('./components/modals/RejectTpaQueueItemModal.vue').default);
app.component('payment-memo-option-lookup-item-modal', require('./components/PaymentMemoOptionLookupItemModal.vue').default);
app.component('timesheet', require('./components/timesheets/Timesheet.vue').default);
app.component('delete-timesheet-rate-modal', require('./components/modals/timsheets/DeleteTimesheetRateModal').default);
app.component('delete-timesheet-modal', require('./components/modals/timsheets/DeleteTimesheetModal').default);
app.component('timesheet-review-modal', require('./components/modals/timsheets/TimesheetReviewModal').default);
app.component('submit-timesheet-for-review-modal', require('./components/modals/timsheets/SubmitForReviewModal.vue').default);
app.component('citizens-fast-edit', require('./components/citizens/CitizensFastEdit.vue').default);
app.component('citizens-bulk-edit', require('./components/citizens/CitizensBulkEdit.vue').default);
app.component('citizens-adjuster-filter', require('./components/citizens/CitizensAdjusterFilter.vue').default);
app.component('citizens-client-filter', require('./components/citizens/CitizensClientFilter.vue').default);
app.component('citizens-field-contact-insured-24', require('./components/citizens/fields/ContactInsured24.vue').default);
app.component('citizens-field-diary-date', require('./components/citizens/fields/DiaryDate.vue').default);
app.component('checkbox-list-toggler', require('./components/CheckboxListToggler.vue').default);
app.component('checkbox-toggler', require('./components/CheckboxToggler.vue').default);
app.component('transaction-initial-modal', require('./components/transactions/modals/initial.vue').default);
app.component('transaction-payment-modal', require('./components/transactions/modals/payment.vue').default);
app.component('transaction-reserve-modal', require('./components/transactions/modals/reserve.vue').default);
app.component('recovery-modal', require('./components/transactions/modals/recovery.vue').default);
app.component('claim-files', require('./components/ClaimFiles.vue').default);
app.component('file-upload-modal', require('./components/modals/FileUploadModal.vue').default);
app.component('smartlist-modal', require('./components/smartlists/SmartlistModal.vue').default);
app.component('smartlist-settings-modal', require('./components/smartlists/SmartlistSettingsModal.vue').default);
app.component('smartlist-record-form', require('./components/smartlists/SmartlistRecordForm.vue').default);
app.component('smartlist-clone-modal', require('./components/smartlists/SmartlistCloneModal.vue').default);
app.component('smartlist-add-adjuster-modal', require('./components/smartlists/SmartlistAddAdjusterModal.vue').default);
app.component('smartlist-delete-adjuster-modal', require('./components/smartlists/SmartlistDeleteAdjusterModal.vue').default);
app.component('smartlist-transfer-adjuster-modal', require('./components/smartlists/SmartlistTransferAdjusterModal.vue').default);
app.component('filter-container', require('./components/filters/FilterContainer.vue').default);
app.component('filter-field-text', require('./components/filters/FilterFieldText.vue').default);
app.component('filter-field-lookup', require('./components/filters/FilterFieldLookup.vue').default);
app.component('filter-field-date', require('./components/filters/FilterFieldDate.vue').default);
app.component('client-timelines', require('./components/clients/ClientTimelines.vue').default);
app.component('timeline', require('./components/clients/Timeline.vue').default);
app.component('assign-journal-template-modal', require('./components/modals/AssignJournalTemplateModal.vue').default);
app.component('approve-fee-schedule-modal', require('./components/modals/ApproveFeeScheduleModal.vue').default);
app.component('tpa-fee', require('./components/tpa-fees/TpaFee.vue').default);
app.component('sync-contact-modal', require('./components/modals/SyncContactModal.vue').default);
app.component('claim-typeahead', require('./components/ClaimTypeahead.vue').default);

app.use(VueSweetalert2);

app.config.compilerOptions.whitespace = "preserve";
app.config.globalProperties.$http = axios;
app.config.globalProperties.$csrf_token = csrf_token;

/**
 * Global modal helper.
 * Please note that jQuery is utilized here because it's built into Bootstrap 4.
 * In Bootstrap 5, the "bootstrap.Modal" object is available for this purpose.
 */
import {useModalStore} from "./stores/modal";
const modalStore = useModalStore()
app.config.globalProperties.$modal = {
  show: (id) => modalStore.showModal(id),
  hide: (id) => modalStore.hideModal(id),
  toggle: (id) => modalStore.toggleModal(id),
};

directives(app);
app.mount('#root');

$(function () {
  Cims.start();
  Claim.load();
  Client.load();
  ClaimFilter.load();
  FeeScheduleForm.load();
  InvoiceForm.load();
  QbExport.load();
  Acknowledgement.load();
  BsImageComponent.load();
  JournalFilter.load();
  Report.load();
  EmailsBulkSelector.load();
  BulkHelper.load();
  TokenLetter.load();
  AdjusterDeploy.load();
  User.load();
  AdjusterSearch.load();
});
